<template>
  <div class="goods-bargain-details">
    <div class="bargain">
      <div class="header" :class="bargainUid != userInfo.uid ? 'on' : ''">
        <div class="people" style="top: 0.56rem">
          {{ bargainCount.lookCount }}人查看 丨
          {{ bargainCount.shareCount }}人分享 丨
          {{ bargainCount.userCount }}人参与
        </div>
        <div
          v-if="bargainUid != userInfo.uid"
          class="pictxt acea-row row-center-wrapper"
        >
          <div class="pictrue"><img :src="bargainUserInfo.avatar" /></div>
          <div class="text">
            {{ bargainUserInfo.nickname }}<span>邀请您帮忙砍价</span>
          </div>
        </div>
      </div>
      <div class="wrapper first">
        <div class="pictxt acea-row row-between-wrapper" @click="goProduct">
          <div class="pictrue">
            <img :src="bargainInfo.image" />
            <!-- <div class="bargain_view">购买数量 X {{ bargainInfo.num }}</div> -->
          </div>
          <div class="text acea-row row-column-around">
            <div class="line2" @click="getBargainHelpCount">
              {{ bargainInfo.title }}
            </div>
            <div class="money font-color">
              当前: ￥<span class="num">{{ bargainInfo.price }}</span>
            </div>
            <div class="successNum">已有{{ bargainSumCount || 0 }}人砍到手</div>
          </div>
        </div>
        <div ref="progressBar" class="cu-progress acea-row row-middle round margin-top">
          <div
            class="acea-row row-middle bg-red"
            :style="{ width: bargainUserHelpInfo.pricePercent + '%' }"
          ></div>
          <div ref="alreadyBox" class="already-box" :style="{ left: bargainPricePercent + '%' }">
            <div class="already">
              已砍{{ bargainUserHelpInfo.alreadyPrice }}元
              <!-- <div class="already-icon-down"></div> -->
            </div>
          </div>
        </div>
        <div class="money acea-row row-between-wrapper">
          <div class="font-color">原价{{ bargainPrice }}元</div>
          <div class="">
            剩余可砍{{ bargainUserHelpInfo.price }}元
          </div>
        </div>
        <!-- 倒计时 -->
        <div class="time acea-row row-center-wrapper">
          <span>{{ countDownDay }}</span> 天 <span>{{ countDownHour }}</span> 时
          <span>{{ countDownMinute }}</span> 分
          <span>{{ countDownSecond }}</span> 秒 后砍价结束
        </div>
      </div>
      <div class="wrapper btnList">
        <!-- 自己砍价 -->
        <div v-if="!userBargainStatus && !bargainUid">
          <div class="bargainBnt" @click="userBargain">立即参与砍价</div>
        </div>
        <div
          v-else-if="
            bargainUserHelpInfo.count > 0 && bargainUid == userInfo.uid
          "
        >
          <div class="bargainBnt" @click="toPay">立即支付</div>
        </div>
        <!-- 帮助砍价、帮砍成功：-->
        <div>
          <div
            v-if="bargainUid == userInfo.uid && bargainUserHelpInfo.price > 0">
            <button class="bargainBnt" @click="setShareInfoStatus">邀请好友帮砍价</button>
          </div>
          <div
            v-else-if="
              bargainUid != userInfo.uid &&
              bargainUserHelpInfo.userBargainStatus &&
              bargainUserHelpInfo.price > 0
            "
          >
            <div class="bargainBnt" @click="setBargainHelp">帮好友砍一刀</div>
          </div>
        </div>
        <div
          v-if="
            bargainUid != userInfo.uid && !bargainUserHelpInfo.userBargainStatus
          "
        >
          <div class="bargainSuccess" v-if="isHelp">
            <span class="iconfont icon-duihao"></span>已成功帮助好友砍价
          </div>
          <div
            class="bargainBnt on"
            v-if="!userBargainStatus"
            @click="currentBargainUser"
          >
            我也要参与
          </div>
        </div>
        
        <div class="bargainBnt on" @click="goBargainList">抢更多商品</div>
        <div class="tip">
          已砍<span class="friends-num">{{ bargainUserHelpInfo.count }}</span
          >次
        </div>
      </div>
      <div class="bargainGang">
        <div class="title acea-row row-center-wrapper">
          <div class="titleCon">砍刀英雄榜</div>
        </div>
        <div class="list">
          <div
            class="item acea-row row-between-wrapper"
            v-for="(item, index) in bargainUserHelpList"
            :key="index"
          >
            <div class="pictxt acea-row row-between-wrapper">
              <div class="pictrue"><img :src="item.avatar" /></div>
              <div class="text">
                <div class="name line1">{{ item.nickname }}</div>
                <div class="line1">{{ item.add_time }}</div>
              </div>
            </div>
            <div class="money font-color">
              <span class="iconfont icon-kanjia"></span>砍掉{{ item.price }}元
            </div>
          </div>
        </div>
        <div 
          class="load font-color"
          v-if="!limitStatus"
          @click="getBargainUser">
          点击加载更多>>
        </div>
      </div>
      <div class="goodsDetails">
        <div class="title acea-row row-center-wrapper">
          <div class="titleCon">商品详情</div>
        </div>
        <div class="conter" v-html="bargainInfo.description">
          
        </div>
      </div>
      <div class="goodsDetails">
        <div class="title acea-row row-center-wrapper">
          <div class="titleCon">砍价规则</div>
        </div>
        <div class="conter" v-html="bargainInfo.rule">
          
        </div>
      </div>
      <div :class="['bargainTip', active == true ? 'on' : '']">
        <div class="pictrue"><img src="@assets/images/bargainBg.png" /></div>
        <div v-if="bargainUid == userInfo.uid">
          <div class="cutOff">
            您已砍掉<span class="font-color" style="color:#fc4141">{{
              bargainUserBargainPrice.price
            }}</span
            >元，听说分享次数越多砍价成功的机会越大哦！
          </div>
          <button @click="setShareInfoStatus" class="tipBnt">邀请好友帮砍价</button>
        </div>
        <div v-else>
          <div class="help font-color">成功帮砍{{bargainUserBargainPrice.price}}元</div>
          <div class="cutOff on">
            您也可以砍价低价拿哦，快去挑选心仪的商品吧~
          </div>
          <div @click="currentBargainUser" class="tipBnt">我也要参与</div>
        </div>
      </div>
      <div
        class="mask"
        v-show="active == true"
        catchtouchmove="true"
        @click="close"
      ></div>
    </div>
    <Product-window
      v-on:changeFun="changeFun"
      :attr="attr"
      :iSplus="iSplus"
    ></Product-window>
    <ShareInfo
      v-on:setShareInfoStatus="setShareInfoStatus"
      :shareInfoStatus="shareInfoStatus"
    ></ShareInfo>
    <FollowPopup
      v-if="isPopupShow"
      :isPopupShow="isPopupShow"
      :flPopupMsg="flPopupMsg"
      @refresh="refresh"
    ></FollowPopup>
    
    <import src="/wxParse/wxParse.wxml" />
  </div>
</template>
<script>
import {
  getBargainDetail,
  getBargainHelpCount,
  getBargainStart,
  getBargainHelpPrice,
  getBargainHelp,
  getBargainHelpList,
  getBargainShare,
  getBargainStartUser,
} from "@api/activity";
import { getUserInfo } from "@api/user";
import { postCartAdd } from "@api/store";
import ShareInfo from "@components/ShareInfo";
import { isWeixin } from "@utils/index";
import { wechatEvevt } from "@libs/wechat";
import { mapGetters } from "vuex";
import FollowPopup from "@components/FollowPopup";
import ProductWindow from "@components/ProductWindow";
export default {
  name: "GoodsBargainDetails",
  components:{
    ShareInfo,
    FollowPopup,
    ProductWindow
  },
  data() {
    return {
      countDownDay: "00",
      countDownHour: "00",
      countDownMinute: "00",
      countDownSecond: "00",
      isHelp: false,
      interval: null,
      active: false,
      id: 0, //砍价产品编号
      userInfo: {}, //当前用户信息
      userInformation:{},
      bargainUid: 0, //开启砍价用户
      bargainUserInfo: {}, //开启砍价用户信息
      bargainUserId: 0, //开启砍价编号
      bargainInfo: [], //砍价产品
      bargainPrice: 0,
      bargainSumCount: 0,
      userBargainStatus: 0, //判断当前用户是否已开启砍价
      productStock: 0, //判断是否售罄；
      quota: 0, //判断是否已限量；
      page: 0,
      limit: 5,
      bargainUserHelpList: [],
      bargainUserHelpInfo: {},
      bargainCount: [], //分享人数  浏览人数 参与人数
      bargainUserBargainPrice:0,

      shareInfoStatus: false,
      posters: false,

      isPopupShow:false, //关注弹窗
      flPopupMsg:{},

      // 产品规格弹窗
      productValue: [],
      attrValue:"",
      attrTxt:"请选择",
      attr: {
        cartAttr: false,
        productAttr: [],
        productSelect: {}
      },
      iSplus: true,
    };
  },
  created() {
    if (this.$route.query.hasOwnProperty("id")) {
      this.id = this.$route.query.id;
      this.bargainUid = this.$route.query.bargain || 0;
    }
  },
  mounted() {
    if (!this.bargainUid) {
      return this.$dialog.error("参数错误");
    };
    this.getUserInfo();
    this.getBargainDetails();
    this.addShareBargain();
  },
  watch:{
    $route(to,from){
      this.id = to.query.id;
      this.bargainUid = to.query.bargain;
      this.getBargainDetails();
      this.addShareBargain();
    }
  },
  methods: {
    getBargainDetails() {
      //获取砍价产品详情
      let that = this;
      let id = that.id;
      getBargainDetail(id,this.bargainUid).then((res) => {
        that.bargainInfo = res.data.bargain;
        that.bargainPrice = res.data.bargain.price;
        that.userInfo = res.data.userInfo;
        that.bargainSumCount = res.data.bargainSumCount;
        that.productStock = res.data.bargain.attr.product_stock;
        that.quota = res.data.bargain.attr.quota;
        that.$set(that.attr,"productAttr",res.data.bargain.productAttr || []);
        that.$set(that,"productValue",res.data.bargain.productValue || []);
        if(that.quota == 0){
          that.$dialog.error("活动已结束，活动商品已售完");
          that.$router.go(-1);
          // setTimeout(function(){
          //   that.$router.go(-1);
          // },1000)
          return;
        };
        that.page = 1;
        that.time2(that.bargainInfo.expire_time, that);
        
        that.getBargainHelpCount();
        that.bargainUserHelpList = [];
        that.gobargainUserInfo();
        that.setOpenShare();
        if(that.userInformation.subscribe === 0) return that.isPopupShow = true;
        if (that.userInfo.uid == that.bargainUid) {
          that.setBargain();
        } else {
          that.getBargainHelpCount();
          that.bargainUserHelpList = [];
          that.gobargainUserInfo();
        }
        
        that.getBargainUser();
      }).catch(err => {
        this.$dialog.message(err.msg);
        setTimeout(() => {
          this.$router.go(-1);
        },500)
      });
      
    },
    getBargainHelpCount() {
      //获取砍价帮总人数、剩余金额、进度条、已经砍掉的价格
      let that = this;
      let data = {
        bargainId: that.id,
        bargainUserUid: that.bargainUid,
      };
      getBargainHelpCount(data).then((res) => {
        var price = that.Sub(that.bargainPrice, res.data.alreadyPrice);
        that.bargainUserHelpInfo = res.data;
        that.bargainInfo.price = parseFloat(price) <= 0 ? 0 : price;
        that.DefaultSelect();
      });
    },
    gobargainUserInfo() {
      //获取开启砍价用户信息
      var that = this;
      var data = {
        bargainId: that.id,
        bargainUserUid: that.bargainUid,
      };
      getBargainStartUser(data).then((res) => {
        that.bargainUserInfo = res.data;
      });
    },
    goProduct(){
      this.$router.push({
        path:`/detail/${this.bargainInfo.product_id}`
      })
    },
    Sub: function (arg1, arg2) {
      arg1 = parseFloat(arg1);
      arg2 = parseFloat(arg2);
      var r1, r2, m, n;
      try {
        r1 = arg1.toString().split(".")[1].length;
      } catch (e) {
        r1 = 0;
      }
      try {
        r2 = arg2.toString().split(".")[1].length;
      } catch (e) {
        r2 = 0;
      }
      m = Math.pow(10, Math.max(r1, r2));
      //动态控制精度长度
      n = r1 >= r2 ? r1 : r2;
      return ((this.Mul(arg1, m) - this.Mul(arg2, m)) / m).toFixed(n);
    },
    //乘法函数，用来得到精确的乘法结果
    //说明：javascript的乘法结果会有误差，在两个浮点数相乘的时候会比较明显。这个函数返回较为精确的乘法结果。
    //调用：$h.Mul(arg1,arg2)
    //返回值：arg1乘以arg2的精确结果
    Mul(arg1, arg2) {
      arg1 = parseFloat(arg1);
      arg2 = parseFloat(arg2);
      var m = 0,
        s1 = arg1.toString(),
        s2 = arg2.toString();
      try {
        m += s1.split(".")[1].length;
      } catch (e) {}
      try {
        m += s2.split(".")[1].length;
      } catch (e) {}
      return (
        (Number(s1.replace(".", "")) * Number(s2.replace(".", ""))) /
        Math.pow(10, m)
      );
    },
    time2(timeStamp, that) {
      var totalSecond = timeStamp - Date.parse(new Date()) / 1000;
      var interval = setInterval(
        function () {
          // 秒数
          var second = totalSecond;
          // // 天数位
          var day = Math.floor(second / 3600 / 24);
          var dayStr = day.toString();
          if (dayStr.length == 1) dayStr = "0" + dayStr;
          // 小时位
          var hr = Math.floor((second - day * 3600 * 24) / (60 * 60));
          var hrStr = hr.toString();
          if (hrStr.length == 1) hrStr = "0" + hrStr;

          // 分钟位
          // var min = Math.floor((second - hr * 3600) / 60);
          var min = Math.floor((second - day * 3600 * 24 - hr * 3600) / 60);
          var minStr = min.toString();
          if (minStr.length == 1) minStr = "0" + minStr;

          // 秒位
          // var sec = second - hrNew * 3600 - min * 60;
          var sec = Math.floor(second - day * 3600 * 24 - hr * 3600 - min * 60);
          var secStr = sec.toString();
          if (secStr.length == 1) secStr = "0" + secStr;

          that.countDownDay = dayStr;
          that.countDownHour = hrStr;
          that.countDownMinute = minStr;
          that.countDownSecond = secStr;
          totalSecond--;
          if (totalSecond <= 0) {
            clearInterval(interval);
            // that.$dialog.message("活动已结束");
            that.countDownDay = "00";
            that.countDownHour = "00";
            that.countDownMinute = "00";
            that.countDownSecond = "00";
          }
        }.bind(that),
        1000
      );

      that.interval = interval;
    },
    setBargain() {
      var that = this;

      getBargainStart({ bargainId: that.id })
        .then((res) => {
          that.bargainUserId = res.data;
          that.getBargainUserBargainPrice();
          that.setBargainHelp();
          that.getBargainHelpCount();
          that.userBargainStatus = 1;
        });
    },
    getBargainUserBargainPrice() {
      //获取帮忙砍价砍掉多少金额
      var that = this;
      var data = {
        bargainId: that.id,
        bargainUserUid: that.bargainUid,
      };
      getBargainHelpPrice(data)
        .then((res) => {
          that.bargainUserBargainPrice = res.data;
          that.active = true;
        })
        .catch((err) => {
          that.active = false;
        });
    },
    setBargainHelp() {
      //帮好友砍价
      if (
        !this.bargainUserHelpInfo.userBargainStatus &&
        this.userInfo.uid != this.bargainUid
      ){
        this.$dialog.message("您已帮好友砍过价");
        return
      }
      var that = this;
      var data = { bargainId: that.id, bargainUserUid: that.bargainUid };
      getBargainHelp(data)
        .then((res) => {
          if(res.status!==200){
            this.$dialog.message(res.msg);
          }
          that.bargainUserHelpList = [];
          that.isHelp = true;
          that.page = 1;

          that.getBargainUser();
          that.getBargainUserBargainPrice();
          that.getBargainHelpCount();
        })
        .catch((err) => {
          that.bargainUserHelpList = [];
          that.page = 1;
          that.getBargainUser();
          return this.$dialog.message(err.msg);
        });
    },
    getBargainUser() {
      //获取砍价帮
      var that = this;
      var data = {
        bargainId: that.id,
        bargainUserUid: that.bargainUid,
        page: that.page,
        limit: that.limit,
      };
      getBargainHelpList(data).then((res) => {
        if (data.limitStatus) return that.$dialog.message("已全部加载");
        var bargainUserHelpList = that.bargainUserHelpList;
        var len = res.data.length;
        bargainUserHelpList = bargainUserHelpList.concat(res.data);
        that.bargainUserHelpList = bargainUserHelpList;
        that.limitStatus = data.limit > len;
        that.page = that.page + 1;
      });
    },
    addShareBargain() {
      //添加分享次数 获取人数
      var that = this;
      getBargainShare(this.id).then((res) => {
        that.bargainCount = res.data;
      });
    },
    currentBargainUser() {
      // 当前用户砍价
      this.bargainUid = this.userInfo.uid;
      this.userBargainStatus = 1;
      this.setBargain();
      this.$router.replace({
        path: '/activity/goods_bargain_details',
        query: {
          id: this.id,
          bargain: this.userInfo.uid
        }
      })
      // this.setOpenShare();
      // app.globalData.openPages = '/pages/activity/goods_bargain_details/index?id=' + this.data.id + '&bargain=' + this.data.bargainUid + '&scene=' + this.data.userInfo.uid;
    },
    goBargainList() {
      this.$router.push({
        path: "/activity/goods_bargain",
      });
    },
    close() {
      this.active = false;
    },
    goPay() {
      //立即支付
      var that = this;
      var data = {
        productId: that.bargainInfo.product_id,
        bargainId: that.id,
        cartNum: that.attr.productSelect.cart_num,
        uniqueId: this.bargainInfo.attr.unique,
        combinationId: 0,
        secKillId: 0,
        new: 1,
      };
      postCartAdd(data)
        .then((res) => {
          this.$router.push({
            path:`/order/submit/${res.data.cartId}`
          })
        })
        .catch((err) => {
          return that.$dialog.error(err.msg);
        });
    },
    // 自己砍价；
    userBargain:function(){
      let that = this;
      if (that.data.userInfo.uid == that.data.bargainUid){
        that.setBargain();
      }
    },
    setShareInfoStatus(){
      this.shareInfoStatus = !this.shareInfoStatus;
      this.posters = false;
    },
    listenerActionClose() {
      this.posters = false;
    },
    setOpenShare: function() {
      var data = this.bargainInfo;
      var href = location.href;
      if (isWeixin()) {
        if (this.isLogin) {
          href =
              href.indexOf("?") === -1
                ? href + "?spread=" + this.userInformation.uid
                : href + "&spread=" + this.userInformation.uid;
                var configAppMessage = {
              desc: data.info,
              title: `您的好友${this.userInformation.nickname}邀请您帮他砍${data.title}`,
              link: href,
              imgUrl: data.image
            };
            wechatEvevt(
              [
                "updateAppMessageShareData",
                "updateTimelineShareData",
                "onMenuShareAppMessage",
                "onMenuShareTimeline"
              ],
              configAppMessage
            )
              .then(res => {
                console.log(res);
              })
              .catch(res => {
                if (res.is_ready) {
                  res.wx.updateAppMessageShareData(configAppMessage);
                  res.wx.onMenuShareAppMessage(configAppMessage);
                  res.wx.updateTimelineShareData(configAppMessage);
                  res.wx.onMenuShareTimeline(configAppMessage);
                }
              });
        } else {
          var configAppMessage = {
            desc: data.info,
            title: `您的好友${this.userInformation.nickname}邀请您帮他砍${data.title}`,
            link: href,
            imgUrl: data.image
          };
          wechatEvevt(
            [
              "updateAppMessageShareData",
              "updateTimelineShareData",
              "onMenuShareAppMessage",
              "onMenuShareTimeline"
            ],
            configAppMessage
          )
            .then(res => {
              console.log(res);
            })
            .catch(res => {
              if (res.is_ready) {
                res.wx.updateAppMessageShareData(configAppMessage);
                res.wx.onMenuShareAppMessage(configAppMessage);
                res.wx.updateTimelineShareData(configAppMessage);
                res.wx.onMenuShareTimeline(configAppMessage);
              }
            });
          
        }
      }
    },
    // 百分比判断
    toPercent(num, total) { 
    return (Math.round(num / total * 10000) / 100.00 + "%");// 小数点后两位百分比
    },
    getUserInfo(){
      getUserInfo().then(res => {
        this.userInformation = res.data;
      }).catch(err => {
        this.$dialog.error('系统错误');
        this.$router.go(-1);
      })
    },
    refresh(){
      this.$router.go(0);
    },
    /**
     * 立即支付
     */
    toPay(){
      let that = this,
        productSelect = that.productValue[this.attrValue];
      //打开属性
      if (that.attrValue) {
        //默认选中了属性，但是没有打开过属性弹窗还是自动打开让用户查看默认选中的属性
        that.attr.cartAttr = !that.isOpen ? true : false;
      } else {
        if (that.isOpen) that.attr.cartAttr = true;
        else that.attr.cartAttr = !that.attr.cartAttr;
      }
      //只有关闭属性弹窗时进行加入购物车
      if (that.attr.cartAttr === true && that.isOpen === false)
        return (that.isOpen = true);
      if (
        !this.attr.productSelect.cart_num ||
        parseInt(this.attr.productSelect.cart_num) <= 0
      )
        return that.$dialog.toast({ mes: "请输入购买数量" });
      //如果有属性,没有选择,提示用户选择
      if (
        that.attr.productAttr.length &&
        productSelect === undefined &&
        that.isOpen === true
      )
        return that.$dialog.toast({ mes: "产品库存不足，请选择其它" });
        return
      let q = {
        productId: that.id,
        cartNum: that.attr.productSelect.cart_num,
        new: news,
        uniqueId:
          that.attr.productSelect !== undefined
            ? that.attr.productSelect.unique
            : ""
      };
      postCartAdd(q)
        .then(function(res) {
          that.isOpen = false;
          that.attr.cartAttr = false;
          if (news) {
            that.$router.push({ path: "/order/submit/" + res.data.cartId });
          } else {
            that.$dialog.toast({
              mes: "添加购物车成功",
              callback: () => {
                that.getCartCount(true);
              }
            });
          }
        })
        .catch(res => {
          that.isOpen = false;
          return that.$dialog.toast({ mes: res.msg });
        });
    },
    /**
     * 默认选中属性
     */
    DefaultSelect: function() {
      let productAttr = this.attr.productAttr,
        value = [];
      for (var key in this.productValue) {
        if (this.productValue[key].stock > 0) {
          value = this.attr.productAttr.length ? key.split(",") : [];
          break;
        }
      }
      for (let i = 0; i < productAttr.length; i++) {
        this.$set(productAttr[i], "index", value[i]);
      }
      //sort();排序函数:数字-英文-汉字；
      let productSelect = this.productValue[value.sort().join(",")];
      
      if (productSelect && productAttr.length) {
        this.$set(
          this.attr.productSelect,
          "store_name",
          this.bargainInfo.title
        ); 
        this.$set(this.attr.productSelect, "image", productSelect.image);
        this.$set(this.attr.productSelect, "price", productSelect.price);
        this.$set(this.attr.productSelect, "stock", productSelect.stock);
        this.$set(this.attr.productSelect, "unique", productSelect.unique);
        this.$set(this.attr.productSelect, "cart_num", 1);
        this.$set(this, "attrValue", value.sort().join(","));
        this.$set(this, "attrTxt", "已选择");
      } else if (!productSelect && productAttr.length) {
        this.$set(
          this.attr.productSelect,
          "store_name",
          this.bargainInfo.title
        );
        this.$set(this.attr.productSelect, "image", this.bargainInfo.image);
        this.$set(this.attr.productSelect, "price", this.bargainInfo.price);
        this.$set(this.attr.productSelect, "stock", 0);
        this.$set(this.attr.productSelect, "unique", "");
        this.$set(this.attr.productSelect, "cart_num", 0);
        this.$set(this, "attrValue", "");
        this.$set(this, "attrTxt", "请选择");
      } else if (!productSelect && !productAttr.length) {
        this.$set(
          this.attr.productSelect,
          "store_name",
          this.bargainInfo.title
        );
        this.$set(this.attr.productSelect, "image", this.bargainInfo.image);
        this.$set(this.attr.productSelect, "price", this.bargainInfo.price);
        this.$set(this.attr.productSelect, "quota_show", this.bargainInfo.quota || 0);
        this.$set(this.attr.productSelect, "quota", this.bargainInfo.quota_show || 0);
        this.$set(this.attr.productSelect, "product_stock", this.bargainInfo.attr.product_stock || 0);
        this.$set(
          this.attr.productSelect,
          "unique",
          this.bargainInfo.unique || ""
        );
        this.$set(this.attr.productSelect, "cart_num", 1);
        this.$set(this, "attrValue", "");
        this.$set(this, "attrTxt", "请选择");
      }
    },
    //将父级向子集多次传送的函数合二为一；
    changeFun: function(opt) {
      if (typeof opt !== "object") opt = {};
      let action = opt.action || "";
      let value = opt.value === undefined ? "" : opt.value;
      this[action] && this[action](value)
    },
    changeattr: function(msg) {
      this.attr.cartAttr = msg;
      this.isOpen = false;
    },
    ChangeCartNum: function(changeValue) {
      //changeValue:是否 加|减
      //获取当前变动属性
      let productSelect = this.productValue[this.attrValue];
      
      //如果没有属性,赋值给商品默认库存
      if (productSelect === undefined && !this.attr.productAttr.length)
        productSelect = this.attr.productSelect;
      //无属性值即库存为0；不存在加减；
      if (productSelect === undefined) return;
      let stock = productSelect.quota_show || 0;
      let num = this.attr.productSelect;
      if (changeValue) {
        num.cart_num++;
        if (num.cart_num > stock) {
          this.$set(this.attr.productSelect, "cart_num", stock ? stock : 1);
          this.$set(this, "cart_num", stock ? stock : 1);
        }
      } else {
        num.cart_num--;
        if (num.cart_num < 1) {
          this.$set(this.attr.productSelect, "cart_num", 1);
          this.$set(this, "cart_num", 1);
        }
      }
    },
  },
  computed:{
    ...mapGetters(["isLogin"]),
    bargainPricePercent(e){
      let pricePercent = this.bargainUserHelpInfo.pricePercent;
      if(pricePercent < 10 ){
        pricePercent = 10;
      }
      if(pricePercent > 90){
        pricePercent = 90;
      }
      return pricePercent
    },
  }
};
</script>
<style scoped>
.bargain{
  background: url("../../assets/images/bargain2.jpg") center top / 100%
    no-repeat;
}
.bargain .wrapper,
.bargain .bargainGang,
.bargain .goodsDetails {
  border: unset;
}
.goods-bargain-details {
  background-color: #1a1818 !important;
}

.bargain .icon-xiangzuo {
  font-size: 0.4rem;
  color: #fff;
  position: fixed;
  top: 0.56rem;
  left: 0.3rem;
  z-index: 99;
}
.bargain .header {
  margin-top: 0;
  padding-top: 0;
  width: unset;
  height: 8.3rem;
  /* background: url("../../assets/images/bargain2.png") center 1.2rem / 100%
    no-repeat; */
  background: none;
}
.bargain .header .pictxt {
  font-size: 0.26rem;
  color: #fff;
  margin: 0 auto;
  padding-top: 1.4rem;
}
.bargain .header .pictxt .pictrue {
  width: 0.56rem;
  height: 0.56rem;
  margin-right: 0.3rem;
}
.bargain .header .pictxt .pictrue img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 1px solid #fff;
}
.bargain .header .pictxt .text text {
  margin-left: 0.2rem;
}
.bargain .header .people {
  color: #1a1818;
  font-size: 0.24rem;
  margin-top: 0.04rem;
  position: fixed;
  right: 0;
  display: inline-block;
  z-index: 5;
  line-height: 0.6rem;
  min-width: 4.6rem;
  padding: 0 0.3rem;
  background: url("../../assets/images/check_bgc.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.bargain .wrapper .time {
  color: #333;
  padding-top: 0.3rem;
  margin-top: 0.2rem;
  border-top: 1px solid rgba(0, 0, 0, 0.2);
}
.bargain .wrapper .time span {
  display: inline-block;
  padding: 0.04rem 0.08rem;
  background: #fdcd70;
  border-radius: 5px;
  margin: 0 0.08rem;
  font-weight: 600;
}
.bargain .wrapper,
.bargain .bargainGang,
.bargain .goodsDetails {
  width: 6.6rem;
  background-color: #fff;
  border-radius: 10px;
  margin: 0.3rem auto;
  box-sizing: border-box;
  padding: 0.16rem 0.24rem 0.47rem;
  position: relative;
}
.bargain .wrapper.first {
  background: #fde6d9;
  margin: -1rem auto 0 auto;
}
.bargain .wrapper.btnList {
  background: none;
  box-shadow: none;
  padding: 0.16rem 0 0.47rem;
}
.bargain .wrapper .pictxt {
  background: rgb(255, 255, 255,.5);
  border-radius: 10px;
  padding: .15rem;
  margin: 0.26rem 0 .9rem 0;
}
.bargain .wrapper .pictxt .pictrue {
  width: 1.8rem;
  height: 1.8rem;
  position: relative;
  border-radius: 10px;
}
.bargain .wrapper .pictxt .pictrue img {
  width: 100%;
  height: 100%;
  border-radius: 3px;
  overflow: hidden;
}
.bargain .wrapper .pictxt .text {
  width: 3.95rem;
  font-size: 0.28rem;
  color: #282828;
  height: 1.8rem;
  padding-left: .32rem;
}
.bargain .wrapper .pictxt .text .money {
  font-weight: bold;
  font-size: 0.24rem;
  color: #fc364e;
}
.bargain .wrapper .pictxt .text .money .num {
  font-size: 0.36rem;
}
.bargain .wrapper .pictxt .text .successNum {
  width: 100%;
  font-size: 0.22rem;
  color: #999;
}
.bargain .wrapper .cu-progress {
  position: relative;
  overflow: visible;
  height: 0.16rem;
  background-color: rgb(255, 255, 255,.5);
  width: 100%;
  border-radius: 10px;
}
.bargain .wrapper .cu-progress .bg-red {
  width: 0;
  height: 100%;
  transition: width 0.6s ease;
  border-radius: 10px;
  background-image: linear-gradient(to right, #ffa82c 0%, #ff554c 100%);
  position: relative;
}
.bargain .wrapper .cu-progress .bg-red:after {
  content: "";
  display: block;
  width: 0.12rem;
  height: 0.12rem;
  position: absolute;
  top: 0.02rem;
  right: 0.04rem;
  background: #ffffff;
  border-radius: 50%;
}
.bargain .wrapper .money {
  font-size: 0.26rem;
  color: #1a1818;
  margin-top: 0.15rem;
  font-weight: 600;
}
.bargain .wrapper .money .font-color {
  color: #f11b09;
}
.bargain .wrapper .bargainSuccess {
  font-size: 0.26rem;
  color: #ffffff;
  text-align: center;
}
.bargain .wrapper .bargainSuccess .iconfont {
  font-size: 0.45rem;
  padding-right: 0.18rem;
  vertical-align: -0.05rem;
}
.bargain .wrapper .bargainBnt {
  font-size: 0.38rem;
  color: #1a1818;
  width: 100%;
  height: 1.16rem;
  text-align: center;
  line-height: 1.12rem;
  margin-top: 0.1rem;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
  background: url("../../assets/images/bargainBnt.png")
    center center / 100% no-repeat;
  background-size: 100%;
  border-radius: 0;
}
.bargain .wrapper .bargainBnt.on {
  color: #ffffff;
  background: url("data:image/jpg;base64,/9j/4QAYRXhpZgAASUkqAAgAAAAAAAAAAAAAAP/sABFEdWNreQABAAQAAABkAAD/4QN8aHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLwA8P3hwYWNrZXQgYmVnaW49Iu+7vyIgaWQ9Ilc1TTBNcENlaGlIenJlU3pOVGN6a2M5ZCI/PiA8eDp4bXBtZXRhIHhtbG5zOng9ImFkb2JlOm5zOm1ldGEvIiB4OnhtcHRrPSJBZG9iZSBYTVAgQ29yZSA1LjYtYzE0NSA3OS4xNjM0OTksIDIwMTgvMDgvMTMtMTY6NDA6MjIgICAgICAgICI+IDxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyI+IDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiIHhtbG5zOnhtcE1NPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvbW0vIiB4bWxuczpzdFJlZj0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL3NUeXBlL1Jlc291cmNlUmVmIyIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bXBNTTpPcmlnaW5hbERvY3VtZW50SUQ9InhtcC5kaWQ6OTI4ZDE4MTgtZDBmNS00N2VkLTk4NzgtYWUwMWRmZTQ0MzIyIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkE3RDBDNTgwMTZFMjExRUNBMjdGQjA0OEZENjA3QjkzIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkE3RDBDNTdGMTZFMjExRUNBMjdGQjA0OEZENjA3QjkzIiB4bXA6Q3JlYXRvclRvb2w9IkFkb2JlIFBob3Rvc2hvcCAyMS4wIChXaW5kb3dzKSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjFkZDlkNTU0LWQ5MDMtYTQ0NC1iYjM0LTExZmZmODFmMDY1ZCIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo5MjhkMTgxOC1kMGY1LTQ3ZWQtOTg3OC1hZTAxZGZlNDQzMjIiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7/7gAOQWRvYmUAZMAAAAAB/9sAhAABAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAgICAgICAgICAgIDAwMDAwMDAwMDAQEBAQEBAQIBAQICAgECAgMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwP/wAARCABlArMDAREAAhEBAxEB/8QAwQABAQEAAwEBAQAAAAAAAAAAAAgJAgYHBQQKAQEBAQEBAQEBAAAAAAAAAAAABQYEAwIBBxAAAQEFCAACBAkJBgcAAAAAAAgEBQdYmAECAwYW1hjYERIhExUXMSIUtzhIeInJMyY2pldnp+cZMkIjJDRWQ2MlRWU3CREBAAACBwYDAggLBgcBAAAAAAMEAQLSVAUGFhOTFJTUVREhEjFhQTKzdBVFhcVRcZEicqLiI1M1NoFCUpIzY6GxYoKyo2Rz/9oADAMBAAIRAxEAPwD+XCFUKYe5eh7YoRQntrHh60Pp4ZchbC3Ljww3Hm6O+bXHhs2M/wDDwn9jMrdbk2FeTbW1muP1+XGdoasdqaMN3O7DtabWpqd0ebm5iJMfR+H+niKKtFNevTR41YVWn2eXl6olbwp9NXxooooo9Vby8KK2ikpKVhSv0pinqplaa1NWHDq0+FaNWo9vn5+mHV8aPXX8KaaaaaKlSjx8aan1Glckf3PftY4Mv11Jky1gW+R2ZcTg6MGFeOyM12zy4eG88/OfEvxXzq13bvovNmYH+9W2/Z6Lcby2XbtnxRgWH1/zp2rTNRfhpjU7T8lSn93V/FUqVaPc+6cxYnDp9MhWqycH4KsCjZ+H469H7yvT769etT735efq7511b1Hxj3kfun8BuUpuYdl86mzJ3Ce38W2c/V3zrq3qPjHvIafwG5Sm5h2TU2ZO4T2/i2zn6u+ddW9R8Y95DT+A3KU3MOyamzJ3Ce38W2c/V3zrq3qPjHvIafwG5Sm5h2TU2ZO4T2/i2zn6u+ddW9R8Y95DT+A3KU3MOyamzJ3Ce38W2c/V3zrq3qPjHvIafwG5Sm5h2TU2ZO4T2/i2zn6u+ddW9R8Y95DT+A3KU3MOyamzJ3Ce38W2c/V3zrq3qPjHvIafwG5Sm5h2TU2ZO4T2/i2zn6u+ddW9R8Y95DT+A3KU3MOyamzJ3Ce38W2c/V3zrq3qPjHvIafwG5Sm5h2TU2ZO4T2/i2zn6u+ddW9R8Y95DT+A3KU3MOyamzJ3Ce38W2c/V3zrq3qPjHvIafwG5Sm5h2TU2ZO4T2/i2zn6u+ddW9R8Y95DT+A3KU3MOyamzJ3Ce38W2c/V3zrq3qPjHvIafwG5Sm5h2TU2ZO4T2/i2zn6u+ddW9R8Y95DT+A3KU3MOyamzJ3Ce38W2c/V3zrq3qPjHvIafwG5Sm5h2TU2ZO4T2/i2zn6u+ddW9R8Y95DT+A3KU3MOyamzJ3Ce38W2c/V3zrq3qPjHvIafwG5Sm5h2TU2ZO4T2/i2zn6u+ddW9R8Y95DT+A3KU3MOyamzJ3Ce38W2c/V3zrq3qPjHvIafwG5Sm5h2TU2ZO4T2/i2zn6u+ddW9R8Y95DT+A3KU3MOyamzJ3Ce38W2c/V3zrq3qPjHvIafwG5Sm5h2TU2ZO4T2/i2zn6u+ddW9R8Y95DT+A3KU3MOyamzJ3Ce38W2c/V3zrq3qPjHvIafwG5Sm5h2TU2ZO4T2/i2zn6u+ddW9R8Y95DT+A3KU3MOyamzJ3Ce38W2c/V3zrq3qPjHvIafwG5Sm5h2TU2ZO4T2/i2zn6u+ddW9R8Y95DT+A3KU3MOyamzJ3Ce38W2c/V3zrq3qPjHvIafwG5Sm5h2TU2ZO4T2/i2zn6u+ddW9R8Y95DT+A3KU3MOyamzJ3Ce38W2c/V3zrq3qPjHvIafwG5Sm5h2TU2ZO4T2/i2zn6u+ddW9R8Y95DT+A3KU3MOyamzJ3Ce38W2c/V3zrq3qPjHvIafwG5Sm5h2TU2ZO4T2/i2zn6u+ddW9R8Y95DT+A3KU3MOyamzJ3Ce38W2c/V3zrq3qPjHvIafwG5Sm5h2TU2ZO4T2/i2zn6u+ddW9R8Y95DT+A3KU3MOyamzJ3Ce38W2c/V3zrq3qPjHvIafwG5Sm5h2TU2ZO4T2/i2zn6u+ddW9R8Y95DT+A3KU3MOyamzJ3Ce38W2c/V3zrq3qPjHvIafwG5Sm5h2TU2ZO4T2/i2zn6u+ddW9R8Y95DT+A3KU3MOyamzJ3Ce38W2c/V3zrq3qPjHvIafwG5Sm5h2TU2ZO4T2/i2zn6u+ddW9R8Y95DT+A3KU3MOyamzJ3Ce38W2c/V3zrq3qPjHvIafwG5Sm5h2TU2ZO4T2/i2zn6u+ddW9R8Y95DT+A3KU3MOyamzJ3Ce38W2c/V3zrq3qPjHvIafwG5Sm5h2TU2ZO4T2/i2zn6u+ddW9R8Y95DT+A3KU3MOyamzJ3Ce38W2c/V3zrq3qPjHvIafwG5Sm5h2TU2ZO4T2/i2zn6u+ddW9R8Y95DT+A3KU3MOyamzJ3Ce38W2c/V3zrq3qPjHvIafwG5Sm5h2TU2ZO4T2/i2zn6u+ddW9R8Y95DT+A3KU3MOyamzJ3Ce38W2c/V3zrq3qPjHvIafwG5Sm5h2TU2ZO4T2/i2zn6u+ddW9R8Y95DT+A3KU3MOyamzJ3Ce38W2c/V3zrq3qPjHvIafwG5Sm5h2TU2ZO4T2/i2zn6u+ddW9R8Y95DT+A3KU3MOyamzJ3Ce38W2c/V3zrq3qPjHvIafwG5Sm5h2TU2ZO4T2/i2zn6u+ddW9R8Y95DT+A3KU3MOyamzJ3Ce38W2c/V3zrq3qPjHvIafwG5Sm5h2TU2ZO4T2/i2zn6u+ddW9R8Y95DT+A3KU3MOyamzJ3Ce38W2c/V3zrq3qPjHvIafwG5Sm5h2TU2ZO4T2/i2zn6u+ddW9R8Y95DT+A3KU3MOyamzJ3Ce38W2c/V3zrq3qPjHvIafwG5Sm5h2TU2ZO4T2/i2zn6u+ddW9R8Y95DT+A3KU3MOyamzJ3Ce38W2c/V3zrq3qPjHvIafwG5Sm5h2TU2ZO4T2/i2zn6u+ddW9R8Y95DT+A3KU3MOyamzJ3Ce38W2c/V3zrq3qPjHvIafwG5Sm5h2TU2ZO4T2/i2zn6u+ddW9R8Y95DT+A3KU3MOyamzJ3Ce38W2c/V3zrq3qPjHvIafwG5Sm5h2TU2ZO4T2/i2zn6u+ddW9R8Y95DT+A3KU3MOyamzJ3Ce38W2c/V3zrq3qPjHvIafwG5Sm5h2TU2ZO4T2/i2zn6u+ddW9R8Y95DT+A3KU3MOyamzJ3Ce38W2c/V3zrq3qPjHvIafwG5Sm5h2TU2ZO4T2/i2zn6u+ddW9R8Y95DT+A3KU3MOyamzJ3Ce38W2c/V3zrq3qPjHvIafwG5Sm5h2TU2ZO4T2/i2zn6u+ddW9R8Y95DT+A3KU3MOyamzJ3Ce38W2c/V3zrq3qPjHvIafwG5Sm5h2TU2ZO4T2/i2zn6u+ddW9R8Y95DT+A3KU3MOyamzJ3Ce38W2c/V3zrq3qPjHvIafwG5Sm5h2TU2ZO4T2/i2zn6u+ddW9R8Y95DT+A3KU3MOyamzJ3Ce38W2c/V3zrq3qPjHvIafwG5Sm5h2TU2ZO4T2/i2zn6u+ddW9R8Y95DT+A3KU3MOyamzJ3Ce38W2c/V3zrq3qPjHvIafwG5Sm5h2TU2ZO4T2/i2zn6u+ddW9R8Y95DT+A3KU3MOyamzJ3Ce38W2c/V3zrq3qPjHvIafwG5Sm5h2TU2ZO4T2/i23K6vla+LesuvpVEdc6sVv5VyRKiRmaKOWGu5/ewm/KkRm/NGW3jgX7PRew8dlxMO9ZbbZbZbZaPoDBKPiSkCpW/DUqValb+ytUoq1qP7KX7qXMFP8AqTszEq/giRK0SrT+OrXprVaf7aHc8vY0LVhNGHktuylkeBym3n/gZAzRkVgYMjwZjbmLEs8GPIedsiM1rNlKE+esytHgzOV8uDDdmW8ZuxMJkb3czWY156YPjEomsHo29WvEj4ZR8erWpprRIVHw16tb40SrV9tarX9Veijxpq1qfD0U+8KmTx2nh61SHL4vT8StUooqQotb4Klep8WHXreypWqemHTT4Va1Sjx9dEke7eIX+xs3fpp7t/0de3/sL/Y3+k/S7/x3+r/5ZX4mX/iVPiev20fE/wAX6Pv9iJwk1/Dr/wCps/i0/H/wez43/T7fcoxcrTfc0f39Bhjt9RlpMjrdKb8uOzD+KzMePCvCxHPn954eHZ8S6150ixff+YG29Z6L7c9ca2zwu+WyybgVHrw+rO0/6s1TTGrU/h2nnUo/7YfoqUe6rQq5ipph4nWkKv8AoydFECrR+DZ+Ven8deJ669PvrUo/LCE9XhvA6K8XGZ8tkOslvLMzI4Ltz2q1M+O7mJnwMTEw72LcZcLGejaw4ba3XsK75rGfAtxcfy22W+Twts8eSZnpSTpq0TNeirTW9ntp/wCVFPhR76fJ2ymHTs9RWrSsOmvVq+32Uf8AOmjxp91Hm8uaWZoY2hoY2vAxmVrZcbFZmpmaMO/gtDO0YF+9hY2Bj4OJZdxMLGwcS7bdvXb1llt29ZbZb6TroporUeNHnRS46aKatNNWtR4VqFNuJF6msyOh3P11QubLzterLgtrDfb8yZMczViMrRcu4uDiYrtfOY2B5MvrMO9Zesu4uDcveFvwEuJjWFwq9MOvFo9VFPhT4UVqf+NFFNCvDwDF4tSiJUg0+itR40eNapRT+SmtRT+Wh9bgoqr9ln67w53efH09hP8AF/Vr2X3pzGf4P69S0cFFVfss/XeHO7x9PYT/ABf1a9k05jP8H9epaOCiqv2WfrvDnd4+nsJ/i/q17JpzGf4P69S06lndJqhIc5cb825vhw2O7Lzru3MR4vBkfuVX7YxYN+/dw/lDSyuB+vRtwmW5ev2efFtw7MPDs9N69ZZ6T2gYvh0zEogwYtFMSn2UeFajx/LRRQ8ZjBMUlYVMePCpohUe2mimrT4f5aaaU6lFKAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADlcv38O/dxMO9euX7l67fuX7l627fuX7ttl67eu3rttlt29dts8bLbPTZaD2edHtbf8AvkiD8i99+o2zS/FDn5pnwwvZvMP2/wD08vfp5PJ63WPvg/O71vj5fa3xvL6v4ph+Cl/VwPpo2vF8J6vh4fw4vZfo7P8Ad/ov6Hx816fpH107HguN9PwcV6uC236W1/e/pe5nov36d61/tbqP+ePORocv/wAhkvmkH5Oqy+Zv6kxD59H+VrpJK6IshNSxH+nTLWZcqs+Tnbm11Px6X38xWND1xnM0Ox94rAyO3Hx8XGwmB4+0GHGZnez+OB4YN67ew7bbuJZ5rSNieDQ8Si1YtNempXq0eFPl4+NHj4/ho8KfOnz8/wAS9hOOxcKhV4NEOivUrU+NHn4eFPhRR+Cnxo8qPLy/GlPM+YHhm3MmYc1Pa3BteuZn49swPO1nw/Us9rwfLe0PFttwMHxveqwbWlpveW742+W74WFaFDqwYVWFU+JVq0UUfioo8KEWNFrR4taNX+PXrU1qfx00+NLTtwf/AFCe7C5XYxP6DzG+nwyseAzt71YM833IyvBowsO7cxGvCdWJk972sPr713zW4djRiXbttvot8PCwy8TK1StXprQ41NWpTT5UU1fHw/t9VHj+Rr4WcK9WHRViwKK1eijzpor+FFPv8PTT4flfY/qm/uK/id/L089K/wC/+p+29NZf/N/7P2D+qb+4r+J38vRpX/f/AFP2zWX/AM3/ALP2D+qb+4r+J38vRpX/AH/1P2zWX/zf+z9h5zFn/wCjD3iND3NORXPC1jyriZsc7a4G58Neb7+Y7cB1PTAvsbzw2Z33cruK7Y1NDFi38O5i3sW9ZhW3vNZdttssOmUy3UlpipHrxaa/opopoo9Pp86POjz9VPwuSdzVXmpWvLQ4NFT11aatNNNb1eVPlT5emjz8PezWNMyYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANbfqc/dJfjumR+uftf7rbf6h+xPvhJC/fp3rX+1uo/5485FfL/8AIZL5pB+TqoeZv6kxD59H+VrpJK6IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA1t+pz90l+O6ZH65+1/utt/qH7E++EkL9+netf7W6j/AJ485FfL/wDIZL5pB+TqoeZv6kxD59H+VrpJK6IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA1t+pz90l+O6ZH65+1/utt/qH7E++EkL9+netf7W6j/njzkV8v8A8hkvmkH5Oqh5m/qTEPn0f5WukkrogAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADW36nP3SX47pkfrn7X+623+ofsT74SQv36d61/tbqP+ePORXy//IZL5pB+TqoeZv6kxD59H+VrpJK6IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA1t+pz90l+O6ZH65+1/utt/qH7E++EkL9+netf7W6j/njzkV8v/wAhkvmkH5Oqh5m/qTEPn0f5WukkrogAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADW36nP3SX47pkfrn7X+623+ofsT74SQv36d61/tbqP8AnjzkV8v/AMhkvmkH5Oqh5m/qTEPn0f5WukkrogAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADW36nP3SX47pkfrn7X+623+ofsT74SQv36d61/tbqP+ePORXy/wDyGS+aQfk6qHmb+pMQ+fR/la6SSuiAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANbfqc/dJfjumR+uftf7rbf6h+xPvhJK/PSulZmPZ6cJuVRH95st/wDu47A9Yq5qeTvacO34L2E1MLVh4ly9Z6L1y/ZbZ6LSvl/+RSVHw0SkKj+2iHVop/4oeZv6jn6fgpnY1NH4qYlamj8tFKSCuiAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANbvC3iT7K/7h/SR8fkv/ABvD+tvrL8n/AGv0Z/znwfkPj/2fSZH639f936X+7fT/AOXl+Nt/qT0f3voT2fa3q/8AHz/EmRRrrxYy5HyUrXLFy144b1cmTYXqGZGb/Fasjxtydlllyw78wvrCu2W4uC5I55Uy3gZgYm+/ZdwGh++2mO54WsVnnqYbW4KPXwiL5U0Vq1eDT/ihVq3qpoo98KtWpqU0e2ir6K395IxWpTPy0PG4PnRWq1Ycej4akWrV9NFan3RqtWivRT7Ka+0q/wB1FhaZ8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD02D8Js3Rtz+5IeZNwGWx4vS1pbHk+Hq0WMGXMo5YdLNiPLM+ds3vjEstZ3FlDKLkZsZveTbi+FxnZcC/e9N7y3beacm4MjL1piN4+mj2UUedNatT5VatWj4a1anwooo+Gml2SMlHxCaqysv4eqnzppp8qtWrR51q9an4KtWjxprU0+yiho/wC/JJerfbOtM86a9ocLNIaUv+zuFHuS0H7/AP1nrfWe9D3s/nz7B8fL7U+J5/J6DN8Di+x9Hoh7Xw4n1erz4na+vZfobP8Adev/AAtV9I4Jt9ptImy8eE9Pp8uE2Xo23/6bT996P8XuR4kf36+8F8+5b2B7N0q3e+H3i+xvcd7qPlbF7e9+WqfzU0F8s+T+X5X/AJr2l8m9m/8AVPkZYxfgeHo431er10bP0eO12nn4bL0/nev2+zy9Pj6vzPUhYH9I8VW4D0+j0U7XaeGx2fl6tt6vzfR4+Ht8/V4ej8/0u953uIRfmZnuy4zVFSFzWytd/CaX6nxhsjzBh+Y1nhbiNuQMqR/eKcIv5WcV6/bbdw2V9vp8NVnhbe+UW3bbt274QPp6HCq00UQotFNHsjU7KJR7q9aFRGh1qffVq1aPc6ZijLkSNWq00xoNNFPtgUbaFT76lWNTAi1aPdXr1qfe6jo1CEx6t6KIOd/T122PXaU5mJ0jw4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhdaaNQhMereiiDnf0bbHrtKczE6Q4fLd7nuUhda5XcvIOddtjXfi6rnPV3D+Na4LqdINwotbPD0+qszdaqSM1jt9Z8HrPYjX5Ph8l74LW0x6v5bGTh+/bRIn6uwh+P+ah+7LLdT87bz0T/p2EKH4/8AdxEXw/yUvYYitT+bU5PdpSs4cgZaT5iXHVbHlyw+zZmXPEfmO9Y9GezLNxUWZs2ZLh6/XllC8+PUWsl7KroZIc2PS3Asxbtr1swbbeOWoh1cSq0YrWiVsQ89lTXq1asKny/O2FWrWr0UVvDx8dpWpjenx8PzPF3TdaJWwqtTg1WFUwzy21FStWrxqPP83iK1apUppq+Ph4bOrRA9Xh4/n+DOY0bKv//Z")
    center center no-repeat;
  background-size: 100%;
  border: none;
}
.bargain .wrapper .tip {
  font-size: 0.28rem;
  color: #ffffff;
  text-align: center;
  margin-top: 0.2rem;
}
.bargain .wrapper .tip .friends-num {
  font-size: 0.34rem;
  color: #f7c2a5;
  text-align: center;
  margin-top: 0.2rem;
}
.bargain .bargainGang,
.bargain .goodsDetails {
  padding-top: 0.7rem;
  padding-bottom: 0.1rem;
  margin-bottom: 0.8rem;
  background: #fde6d9;
}
.bargain .bargainGang .title,
.bargain .goodsDetails .title {
  font-size: 0.32rem;
  height: 0.6rem;
  color: #1a1818;
  border-radius: 5px;
  background: linear-gradient(#fee8db, #f7c1a3);
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -50%) skew(-6deg);
  box-shadow: 0 0 6px 0px rgb(26,24,24,.5);
  margin-top: 0;
}
.bargain .bargainGang .title .pictrue.on,
.bargain .goodsDetails .title .pictrue.on {
  transform: rotate(180deg);
}
.bargain .bargainGang .title .pictrue img,
.bargain .goodsDetails .title .pictrue img {
  width: 100%;
  height: 100%;
  display: block;
}
.bargain .bargainGang .title .titleCon,
.bargain .goodsDetails .title .titleCon {
  margin: 0 0.4rem;
}
.bargain .bargainGang .list .item {
  border-bottom: 1px dashed #ddd;
  height: 1.12rem;
}
.bargain .bargainGang .list .item .pictxt {
  width: 3.1rem;
}
.bargain .bargainGang .list .item .pictxt .pictrue {
  width: 0.7rem;
  height: 0.7rem;
}
.bargain .bargainGang .list .item .pictxt .pictrue img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 1px solid #ff554c;
}
.bargain .bargainGang .list .item .pictxt .text {
  width: 2.25rem;
  font-size: 0.2rem;
  color: #999;
}
.bargain .bargainGang .list .item .pictxt .text .name {
  font-size: 0.25rem;
  color: #282828;
  margin-bottom: 0.07rem;
}
.bargain .bargainGang .list .item .money {
  font-size: 0.25rem;
}
.bargain .bargainGang .list .item .money.font-color {
  color: #f11b09;
}
.bargain .bargainGang .list .item .money .iconfont {
  font-size: 0.35rem;
  vertical-align: middle;
  margin-right: 0.1rem;
}
.bargain .bargainGang .load {
  font-size: 0.24rem;
  text-align: center;
  line-height: 0.8rem;
  height: 0.8rem;
}
.bargain .goodsDetails ~ .goodsDetails {
  margin-bottom: 0.5rem;
}
.bargain .goodsDetails .conter {
  margin-top: 0.2rem;
}
.bargain .goodsDetails .conter img {
  width: 100% !important;
  display: block;
}
/* .bargain .bargainTip {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 5.6rem;
  margin-left: -2.8rem;
  z-index: 99;
  border-radius: 10px;
  background-color: #fff;
  transition: all 0.3s ease-in-out 0s;
  opacity: 0;
  transform: scale(0);
  padding-bottom: 0.6rem;
  margin-top: -3.3rem;
} */
/* .bargain .bargainTip.on {
  opacity: 1;
  transform: scale(1);
} */
.bargain .bargainTip .pictrue {
  width: 100%;
  height: 3.21rem;
}
.bargain .bargainTip .pictrue img {
  width: 100%;
  height: 100%;
  border-radius: 10px 10px 0 0;
}
.bargain .bargainTip .cutOff {
  font-size: 0.3rem;
  color: #666;
  padding: 0 0.29rem;
  text-align: center;
  margin-top: 0.5rem;
}
.bargain .bargainTip .cutOff.on {
  margin-top: 0.26rem;
}
.bargain .bargainTip .help {
  font-size: 0.32rem;
  font-weight: bold;
  text-align: center;
  margin-top: 0.4rem;
}
.bargain .bargainTip .tipBnt {
  display: block;
  font-size: 0.32rem;
  color: #1a1818;
  width: 3.6rem;
  height: 1.08rem;
  border-radius: 20px;
  background: url("../../assets/images/tipbtnsucc.png") center center / 100% no-repeat;
  /* background-image: linear-gradient(#ff9993 0%, #f11b09 100%); */
  text-align: center;
  line-height: 0.82rem;
  margin: 0.5rem auto 0 auto;
  font-family: unset;
  font-weight: 600;
}
.bargain_view {
  width: 1.8rem;
  height: 0.48rem;
  background: rgba(0, 0, 0, 0.5);
  opacity: 1;
  border-radius: 0 0 3px 3px;
  position: absolute;
  bottom: 0;
  font-size: 0.22rem;
  color: #fff;
  text-align: center;
  line-height: 0.48rem;
}
.iconfonts {
  font-size: 0.22rem !important;
}
.wxParse-div {
  width: auto !important;
  height: auto !important;
}
.already-box{
  position: absolute;
  left: 10%;
  top: -.56rem;
  transform: translateX(-50%);
  white-space: nowrap;
  transition: .5s;
}
.already-box .already{
  position: relative;
  padding: 0 .12rem;
  height: .4rem;
  line-height: .4rem;
  text-align: center;
  background: #fdbd2a;
  color: #fff;
  border-radius: 3px;
  font-size: .26rem;
}
/* .already-box .already::before{
  position: absolute;
  display: block;
  content: "";
  border: .1rem solid #fdbd2a;
  border-right-color: transparent;
  border-bottom-color: transparent;
  border-left-color: transparent;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
} */
.already-icon-down{
  position: absolute;
  display: block;
  border: .1rem solid #fdbd2a;
  border-right-color: transparent;
  border-bottom-color: transparent;
  border-left-color: transparent;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
}
</style>